import { Divider, HStack, Text, DataList, DataItem } from '@cad-arc';
import { EntityLocation } from './entity-location';
import { getPersonDisplayDOBOrAge } from '../helpers';
import { Person } from '../../../../../fr-entity-panels/types';
import { CARD_CONTAINERS_PADDING } from '../constants';
import { CommonSize } from '../../../../../common/helpers/utils';
import { getDataItemText } from '../../../../../common/helpers/component-utils';

export function PersonCardExpandableContent({
    person,
    size = 'sm',
    showViewOnMap = true,
}: {
    person: Person;
    size?: CommonSize;
    showViewOnMap?: boolean;
}) {
    const {
        location,
        dateOfBirth,
        driversLicenseNumber,
        driversLicenseState,
        notes,
        ageMax,
        ageMin,
    } = person;

    return (
        <>
            {location && (
                <>
                    <Divider />
                    <DataList style={{ width: '100%', padding: CARD_CONTAINERS_PADDING }}>
                        <EntityLocation
                            dataKey="Location"
                            location={location}
                            size={size}
                            showViewOnMap={showViewOnMap}
                        />
                    </DataList>
                </>
            )}
            <Divider />
            <HStack alignItems="flex-start" padding={CARD_CONTAINERS_PADDING} width="100%">
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="DL#">{getDataItemText(size, driversLicenseNumber)}</DataItem>
                    <Text fontSize={size}>
                        <DataItem dataKey={dateOfBirth ? 'DOB' : 'Age'}>
                            {getPersonDisplayDOBOrAge({ dateOfBirth, ageMax, ageMin })}
                        </DataItem>
                    </Text>
                </DataList>
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="DL State">
                        {getDataItemText(size, driversLicenseState?.label)}
                    </DataItem>
                </DataList>
            </HStack>
            <Divider />
            <DataList style={{ width: '100%', padding: CARD_CONTAINERS_PADDING }}>
                <DataItem dataKey="Notes">{getDataItemText(size, notes)}</DataItem>
            </DataList>
        </>
    );
}
